import { Dialog } from "antd-mobile";
import "./style.scss";

const CustomDialog = ({ type, dialogProps, customClass = "" }) => {
  const showDialog = (type) => {
    switch (type) {
      case "show":
        Dialog.show({
          className: `agent-mobile-custom-dialog ${customClass}`,
          ...dialogProps,
        });
        break;
      case "alert":
        Dialog.alert({
          className: `agent-mobile-custom-dialog ${customClass}`,
          ...dialogProps,
        });
        break;
      case "confirm":
        Dialog.confirm({
          className: `agent-mobile-custom-dialog ${customClass}`,
          ...dialogProps,
        });
        break;
      default:
        Dialog.show({
          className: `agent-mobile-custom-dialog ${customClass}`,
          ...dialogProps,
        });
        break;
    }
  };
  showDialog(type);
};

export default CustomDialog;
